var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWitchSteak(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 86.625,
    height: 86.625,
    viewBox: "0 0 86.625 86.625",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "svgexport-6_60_",
    "data-name": "svgexport-6 (60)",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3820",
    "data-name": "Group 3820",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5476",
    "data-name": "Path 5476",
    d: "M36.115,305.68,12.554,332.087A7.163,7.163,0,1,1,2.446,321.98l26.407-23.561s2.277-.43,4.984,2.277S36.115,305.68,36.115,305.68Z",
    transform: "translate(0 -247.909)",
    fill: "#176eb5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5477",
    "data-name": "Path 5477",
    d: "M46.417,316.985,22.856,343.392a7.163,7.163,0,0,1-10.456.349L44.14,312c2.707,2.707,2.277,4.984,2.277,4.984Z",
    transform: "translate(-10.302 -259.214)",
    fill: "#004377"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5478",
    "data-name": "Path 5478",
    d: "M193.12,213.415,177.8,230.581l-7.262-7.262L187.706,208Z",
    transform: "translate(-141.686 -172.81)",
    fill: "#004377"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5479",
    "data-name": "Path 5479",
    d: "M210.949,226.708l-15.318,17.166L192,240.243,208.242,224Z",
    transform: "translate(-159.516 -186.103)",
    fill: "#176eb5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5480",
    "data-name": "Path 5480",
    d: "M208.087,127.777h-10.9l-7.185,9.791a2.54,2.54,0,0,1-4.553-1.1L183.5,124.112l-12.353-1.956a2.54,2.54,0,0,1-1.1-4.553l9.791-7.185v-10.9a2.54,2.54,0,0,1,4.013-2.066l8.485,6.062,12-3.367a2.538,2.538,0,0,1,3.128,3.128l-3.367,12,6.062,8.485a2.54,2.54,0,0,1-2.066,4.013Z",
    transform: "translate(-140.412 -80.573)",
    fill: "#ffd10a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5481",
    "data-name": "Path 5481",
    d: "M281.316,142.515a2.54,2.54,0,0,1-2.066,4.013h-10.9l-7.185,9.791a2.54,2.54,0,0,1-4.553-1.1l-1.956-12.353,23.313-23.313a2.538,2.538,0,0,1,.648,2.48l-3.367,12Z",
    transform: "translate(-211.574 -99.324)",
    fill: "#f0c407"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5482",
    "data-name": "Path 5482",
    d: "M447.2,6.6a2.539,2.539,0,0,1-2.538,2.538h-1.523V10.66a2.538,2.538,0,1,1-5.076,0V9.137h-1.523a2.538,2.538,0,0,1,0-5.076h1.523V2.539a2.538,2.538,0,1,1,5.076,0V4.062h1.523A2.539,2.539,0,0,1,447.2,6.6Z",
    transform: "translate(-360.572 -0.001)",
    fill: "#ffd10a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5483",
    "data-name": "Path 5483",
    d: "M467.136,26.539a2.539,2.539,0,0,1-2.538,2.538h-1.523V30.6a2.538,2.538,0,0,1-5.076,0V29.077L463.076,24H464.6A2.539,2.539,0,0,1,467.136,26.539Z",
    transform: "translate(-380.511 -19.94)",
    fill: "#ffd10a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5484",
    "data-name": "Path 5484",
    d: "M283.659,21.062h-1.523V19.539a2.538,2.538,0,1,0-5.076,0v1.523h-1.523a2.538,2.538,0,1,0,0,5.076h1.523V27.66a2.538,2.538,0,1,0,5.076,0V26.137h1.523a2.538,2.538,0,0,0,0-5.076Z",
    transform: "translate(-226.811 -14.125)",
    fill: "#c3bedd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5485",
    "data-name": "Path 5485",
    d: "M421.061,171.66a2.538,2.538,0,1,0,5.076,0v-1.523h1.523a2.538,2.538,0,1,0,0-5.076h-1.523v-1.523a2.538,2.538,0,1,0-5.076,0v1.523h-1.523a2.538,2.538,0,1,0,0,5.076h1.523Z",
    transform: "translate(-346.448 -133.762)",
    fill: "#cd229a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5486",
    "data-name": "Path 5486",
    d: "M444.659,309.062h-1.523v-1.523a2.538,2.538,0,0,0-5.076,0v1.523h-1.523a2.538,2.538,0,0,0,0,5.076h1.523v1.523a2.538,2.538,0,1,0,5.076,0v-1.523h1.523a2.538,2.538,0,0,0,0-5.076Z",
    transform: "translate(-360.572 -253.398)",
    fill: "#ffd10a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5487",
    "data-name": "Path 5487",
    d: "M139.659,4.062h-1.523V2.539a2.538,2.538,0,1,0-5.076,0V4.062h-1.523a2.538,2.538,0,1,0,0,5.076h1.523V10.66a2.538,2.538,0,1,0,5.076,0V9.137h1.523a2.538,2.538,0,0,0,0-5.076Z",
    transform: "translate(-107.175 -0.001)",
    fill: "#ffd10a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5488",
    "data-name": "Path 5488",
    d: "M94.269,94.747l-9.475-5.414a2.538,2.538,0,1,0-2.518,4.407l9.475,5.414a2.538,2.538,0,1,0,2.518-4.407Z",
    transform: "translate(-67.293 -73.941)",
    fill: "#f6f9f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5489",
    "data-name": "Path 5489",
    d: "M54.051,169.018l-10.828,1.354a2.538,2.538,0,0,0,.63,5.036l10.828-1.354a2.538,2.538,0,0,0-.63-5.036Z",
    transform: "translate(-34.063 -140.405)",
    fill: "#c9249a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5490",
    "data-name": "Path 5490",
    d: "M365.739,346.276a2.538,2.538,0,0,0-4.407,2.518l5.414,9.475a2.538,2.538,0,1,0,4.407-2.518Z",
    transform: "translate(-299.92 -286.628)",
    fill: "#e2dff4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5491",
    "data-name": "Path 5491",
    d: "M309.2,377.019a2.537,2.537,0,0,0-2.833,2.2l-1.354,10.828a2.538,2.538,0,1,0,5.036.629l1.354-10.828A2.537,2.537,0,0,0,309.2,377.019Z",
    transform: "translate(-253.396 -313.215)",
    fill: "#cd229a"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWitchSteak);
export default __webpack_public_path__ + "static/media/witchSteak.e4115f02f0a3321a8c0278519c45abe3.svg";
export { ForwardRef as ReactComponent };